import * as moment from 'moment';

import { BASE_DATE_FORMAT } from '../../constants';

type DateRange = {
	dateStart: string;
	dateEnd: string;
}

function prettyDate(date: string) {
	return moment(date, BASE_DATE_FORMAT).format('DD.MM.YYYY');
}

function getIsDateInDateRange(date: string, dateRange: DateRange): boolean {
	const dateMoment = moment(date, BASE_DATE_FORMAT);
	const appDateRangeStart = moment(dateRange.dateStart, BASE_DATE_FORMAT);
	const appDateRangeEnd = moment(dateRange.dateEnd, BASE_DATE_FORMAT);

	return !dateMoment.isBefore(appDateRangeStart) && !dateMoment.isAfter(appDateRangeEnd);
}

export {
	prettyDate,
	getIsDateInDateRange,
};
